import { fromJS } from "immutable";
import UploadedFile from "~/records/record.uploaded_file.jsx";
import UploadedFileMap from "~/records/record.uploaded_file_map.jsx";
import * as actionTypes from "~/store/action_types";

export const uploaded_file = (state = new UploadedFile(), action) => {
  switch (action.type) {
    case actionTypes.UPLOAD_FILE_BEGINS:
      return new UploadedFile({
        code: action.file.code,
        sizeValue: action.file.size,
        name: action.file.name,
        mime_type: action.file.type,
        uploading: true,
        progress: 0,
      });
    case actionTypes.UPLOAD_FILE_LOADING:
      return new UploadedFile({
        code: action.file.code,
        sizeValue: action.file.size,
        name: action.file.name,
        mime_type: action.file.type,
        uploading: true,
        progress: action.progress,
      });
    case actionTypes.UPLOAD_FILE_ERROR:
      return new UploadedFile({
        ...state.toObject(),
        uploading: false,
        error: action.error,
      });
    default:
      return state;
  }
};

const mergeEntities = (state, newUploadedFiles) => {
  return state.merge(newUploadedFiles.map((f) => new UploadedFile(f)));
};

const uploaded_files = (state = new UploadedFileMap(), action) => {
  switch (action.type) {
    case actionTypes.UPLOAD_FILE_BEGINS:
      return state.set(action.file.code, uploaded_file(state.get(action.file.code, undefined), action));
    case actionTypes.UPLOAD_FILE_LOADING:
    case actionTypes.UPLOAD_FILE_ERROR:
      if (!action.file || !state.has(action.file.code)) {
        return state;
      }
      return state.set(action.file.code, uploaded_file(state.get(action.file.code, undefined), action));
    case actionTypes.UPLOAD_FILE_SUCCESS:
      if (
        !action.response ||
        !action.response.entities ||
        !action.response.entities.uploaded_files ||
        !action.file ||
        !state.has(action.file.code)
      ) {
        return state;
      }
      Object.keys(action.response.entities.uploaded_files).forEach((key) => {
        let { size, ...rest } = action.response.entities.uploaded_files[key];
        action.response.entities.uploaded_files[key] = {
          ...rest,
          sizeValue: size,
          progress: 100,
        };
      });
      return mergeEntities(state.delete(action.file.code), fromJS(action.response.entities.uploaded_files));
    case actionTypes.UPLOAD_GDRIVE_FILES_LOADING:
      if (action.docs) {
        action.docs.forEach((doc) => {
          state = state.set(
            doc.code,
            new UploadedFile({
              code: doc.code,
              sizeValue: doc.sizeBytes,
              name: doc.name,
              mime_type: doc.mimeType,
              uploading: true,
              progress: 100,
            })
          );
        });
      }
      return state;
    case actionTypes.UPLOAD_DROPBOX_FILES_LOADING:
      if (action.files) {
        action.files.forEach((file) => {
          state = state.set(
            file.code,
            new UploadedFile({
              code: file.code,
              sizeValue: file.bytes,
              name: file.name,
              uploading: true,
              progress: 100,
            })
          );
        });
      }
      return state;
    case actionTypes.UPLOAD_GDRIVE_FILES_SUCCESS:
    case actionTypes.UPLOAD_DROPBOX_FILES_SUCCESS:
      if (!action.response || !action.response.entities || !action.response.entities.uploaded_files) {
        return state;
      }
      Object.keys(action.response.entities.uploaded_files).forEach((key) => {
        let { size, ...rest } = action.response.entities.uploaded_files[key];
        action.response.entities.uploaded_files[key] = {
          ...rest,
          sizeValue: size,
        };
      });
      if (action.files) {
        action.files.forEach((file) => {
          state = state.delete(file.code);
        });
      }
      if (action.docs) {
        action.docs.forEach((doc) => {
          state = state.delete(doc.code);
        });
      }
      return mergeEntities(state, fromJS(action.response.entities.uploaded_files));
    case actionTypes.UPLOAD_GDRIVE_FILES_ERROR:
      return state;
    case actionTypes.REMOVE_UNFINISHED_FILE_UPLOADS:
      return state.filter((uploadedFile) => !uploadedFile.uploading);
    case actionTypes.REMOVE_UPLOADED_FILE:
      return state.delete(action.code);
    case actionTypes.RESET_UPLOADED_FILES:
      return new UploadedFileMap();
    case actionTypes.EDIT_DISCUSSION_SUCCESS:
    case actionTypes.EDIT_NOTE_SUCCESS:
    case actionTypes.EDIT_TASK_SUCCESS: {
      const { attributes = {} } = action;
      const { attach_uploaded_files = [] } = attributes;
      if (attach_uploaded_files.length > 0) {
        attach_uploaded_files.forEach((code) => {
          state = state.delete(code);
        });
      }
      return state;
    }
    default:
      if (action.response && action.response.entities && action.response.entities.uploaded_files) {
        Object.keys(action.response.entities.uploaded_files).forEach((key) => {
          let { size, ...rest } = action.response.entities.uploaded_files[key];
          action.response.entities.uploaded_files[key] = {
            ...rest,
            sizeValue: size,
          };
        });
        return mergeEntities(state, fromJS(action.response.entities.uploaded_files));
      }
      return state;
  }
};

export default uploaded_files;
